import api from "../utils/api";

export const createStudent = async (formData) => {
  try {
    const response = await api.post("/student/createStudent", formData);
    console.log("response", response);
  } catch (error) {
    console.log("error", error);
  }
};

export const getAllStudents = async () => {
  try {
    const response = await api.get("student/getAllStudents");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginStudent = async (loginData) => {
  try {
    const response = await api.post(`/student/loginStudent`, loginData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStudent = async (studentId, formData) => {
  try {
    const response = await api.put(
      `student/updateStudent/${studentId}`,
      formData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStudent = async (studentId) => {
  try {
    const response = await api.delete(`student/deleteStudent/${studentId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
